import * as React from 'react'
import { useState } from 'react'
import { QueryClientProvider } from 'react-query'
import buildQueryClient from '../../helpers/queryClient'

import CommonContext, { WarehouseType } from '../../CommonContext'
import JobPlanningsTable from './JobPlanningsTable'

type ListAppProps = {
  availableAreas: string[]
  availableWorktypes: any[]
  availableWorkcards: any[]
  availablePartners: any[]
  availableWarehouses: WarehouseType[]
  availableUsers: any[]
  availableTasks: any[]
  availableApprovalFormTemplates: any[]
  availableDepartments: any[]
  allPartners: any[]
  createSMProjectUrl: string
  smProjectUrl: string
  dynamicsnavPrefix?: string
  currentUser: any
}

export default function ListApp(props: ListAppProps) {
  const {
    availableAreas,
    availableWorktypes,
    availableWorkcards,
    availablePartners,
    availableWarehouses,
    availableUsers,
    availableTasks,
    availableApprovalFormTemplates,
    availableDepartments,
    createSMProjectUrl,
    smProjectUrl,
    dynamicsnavPrefix,
    allPartners,
    currentUser,
  } = props

  const queryClient = buildQueryClient()

  const [dictionaries, setDictionaries] = useState({
    availableAreas,
    availableWorktypes,
    availableWorkcards,
    availablePartners,
    availableWarehouses,
    availableUsers,
    availableTasks,
    availableApprovalFormTemplates,
    availableDepartments,
    allPartners,
    createSMProjectUrl,
    smProjectUrl,
    dynamicsnavPrefix,
    currentUser,
    updateCurrentUser: user => {
      setDictionaries({ ...dictionaries, currentUser: user })
    },
  })

  return (
    <CommonContext.Provider value={dictionaries}>
      <QueryClientProvider client={queryClient}>
        <JobPlanningsTable />
      </QueryClientProvider>
    </CommonContext.Provider>
  )
}
